<template>
  <div class="m-page-main u-mt15 pull-relative" v-if="tempSett.visible == 1">
    <div class="c-ibox">
      <div class="ibox-title">
        <div class="ibox-icon-name">
          <div class="ibox-icon">
            <img :src="tempSett.iconUrl || './images/icon.png'" alt="" />
          </div>
          <div class="ibox-name" :style="{ color: tempSett.titleColor }">
            {{ tempSett.title || $t("ABOUT_TO_START") }}
          </div>
        </div>
        <div class="ibox-more">
          <router-link to="/live" class="more">{{ $t("MORE") }}</router-link>
        </div>
      </div>
      <div class="ibox-content">
        <ItemDouble
          v-for="o in list"
          :key="o.id"
          :info="o"
          :sett="tempSett"
        ></ItemDouble>
        <div class="m-area pull-left" v-if="!isLoading && list.length == 0">
          <a-empty :description="$t('NODATA')"></a-empty>
        </div>
      </div>
    </div>
    <div class="m-loading-data" v-if="isLoading"></div>
  </div>
</template>

<script>
import ItemDouble from "./ItemDouble";
import { tempConfig } from "../store/interface";
import account from "../services/account";
import { URLS } from "fire-wind-water/url";

const tenantId = URLS.getURL("tenantId");

export default {
  name: "AboutTo",
  data() {
    return {
      tempSett: tempConfig.willStartConfig,
      list: [],
      isLoading: true
    };
  },
  created() {
    this.tempSett = this.$store.getters.getterTempConfig.willStartConfig;
    if (this.tempSett.visible == 1) {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.isLoading = true;
      account
        .getIndexList({ tenantId: tenantId, type: "willStart" })
        .then(data => {
          this.isLoading = false;
          if (data.result == 0) {
            this.list = data.content.items;
            if (this.list.length > 2) {
              this.list.splice(2, this.list.length - 2);
            }
          } else {
            this.$message.error(data.desc);
          }
        });
    }
  },
  components: {
    ItemDouble
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val.willStartConfig;
      if (this.tempSett.visible == 1) {
        this.getList();
      }
    }
  }
};
</script>

<style scoped></style>
